<div class="account-menu">
    <form [formGroup]="loginForm" class="account-menu__form" *ngIf="!user">
        <div class="account-menu__form-title">Accedi al Tuo Account</div>
        <div class="form-group">
            <label for="header-signin-email" class="sr-only">Email</label>
            <input id="header-signin-email" type="email" class="form-control form-control-sm"
                placeholder="Email" formControlName="username">
            <small *ngIf="isControlHasError('username'); let error"
                class="text-danger">{{error}}</small>
        </div>
        <div class="form-group">
            <label for="header-signin-password" class="sr-only">Password</label>
            <div class="input-group">
                <input id="header-signin-password" type="password" formControlName="password"
                    class="form-control form-control-sm" placeholder="Password">
                <span (click)="togglePassword($event)" class="fa fa-fw fa-eye toggle-password"></span>
            </div>
            <small *ngIf="isControlHasError('password'); let error"
                class="text-danger">{{error}}</small>
            <small class="form-text text-muted">
                <a routerLink="/auth/restore">Recupera Password</a>
            </small>
        </div>
        <div class="form-group account-menu__form-button">
            <button type="submit" class="btn btn-primary btn-sm" (click)="submit()" [disabled]="loginForm.invalid">Login</button>
        </div>
        <div class="account-menu__form-link"><a routerLink="/auth/register"
                (click)="closeMenu.emit()">Registrati</a></div>
    </form>
    <ng-container *ngIf="user">
        <div class="account-menu__divider"></div>
        <a routerLink="/account/dashboard" class="account-menu__user" (click)="closeMenu.emit()">
            <!-- <div class="account-menu__user-avatar">
                <img src="assets/images/avatars/avatar-3.jpg" alt="">
            </div> -->
            <div class="account-menu__user-info">
                <div class="account-menu__user-name">{{user.nome}} {{user.cognome}}</div>
                <div class="account-menu__user-email">{{user.email}}</div>
            </div>
        </a>
        <div class="account-menu__divider"></div>
        <ul class="account-menu__links">
            <li><a routerLink="/account/orders" (click)="closeMenu.emit()">Ordini</a></li>
            <li><a routerLink="/account/addresses" (click)="closeMenu.emit()">Indirizzi</a></li>
        </ul>
        <div class="account-menu__divider"></div>
        <ul class="account-menu__links">
            <li><a routerLink="/auth/login" (click)="logout()">Esci</a></li>
        </ul>
    </ng-container>
</div>